<a
  class="soe-float-button"
  *ngIf="showScrollButton()"
  (click)="scrollToTop()"
>
  <i class="fa fa-arrow-up soe-float"></i>
</a>
